import { EtapaProjeto, StatusEtapa } from 'models/projeto';
import { getFormattedText } from './htmlFormat';

const languageValues = {
  buttons: {
    fotosVideos: 'Adicionar fotos e vídeos',
    review: 'Revisão',
  },
  components: {
    newAutoCompleteField: {
      emptyMessage: 'Nenhuma opção foi carregada.',
      notFoundMessage: 'Nenhuma opção encontrada',
    },
    AlertCard: {
      camposObrigatoriosRequired: 'Há campos obrigatórios que necessitam de preenchimento!',
      camposObrigatoriosRequiredCadastroEscolas: 'Há campos obrigatórios que necessitam de preenchimento no cadastro de escolas!',
      VerTodasAsEscolas: 'Ver todas as escolas'
    }
  },
  constants: {
    yesNo: (b?: boolean) => (b ? 'Sim' : 'Não'),
  },
  inputs: {
    idEscola: {
      label: 'Nome da instituição',
      placeholder: 'Selecione a instituição...',
      loading: 'Carregando instituições...',
      required: 'Instituição é obrigatória!',
    },
    recorrencias: {
      labelTipos: 'Recorrência',
    },
    codigoCooperativa: {
      label: 'Cooperativa',
      placeholder: 'Selecione a cooperativa...',
      loading: 'Carregando cooperativas...',
      required: 'Cooperativa é obrigarória!',
    },
    cpfsAssessores: {
      label: 'Assessor(es) pedagógico(s)',
      placeholder: 'Selecione o(s) assessor(es)...',
      loading: 'Carregando assessores...',
      required: 'Selecione pelo menos um assessor!',
    },
    cpfsProfessores: {
      label: 'Educador(es)',
      placeholder: 'Selecione o(s) educador(es)...',
      loading: 'Carregando educadores...',
      required: 'Selecione pelo menos um educador!',
    },
    descricaoTurma: {
      label: 'Turma(s)',
      placeholder: 'Digite a(s) turma(s)...',
      required: 'Campo obrigatório!',
    },
    quantidadeAlunosTurma: {
      label: 'Quantidade de crianças e/ou adolescentes',
      placeholder: 'Digite a quantidade de crianças e/ou adolescentes...',
      required: 'Quantidade é obrigatória!',
    },
    idEtapasEnsino: {
      label: 'Etapa(s) da educação básica',
      placeholder: 'Selecione a(s) etapa(s) da educação básica...',
      loading: 'Carregando etapas...',
      required: 'Selecione pelo menos uma etapa!',
    },
    modalidades: {
      label: 'Modalidade(s)',
      placeholder: 'Selecione a(s) modalidade(s)...',
      loading: 'Carregando etapas...',
      required: 'Selecione pelo menos uma modalidade!',
    },
    preTitulo: {
      label: 'Pré-título',
      placeholder: 'Digite o pré-título...',
      required: 'Pré-título é obrigatório!',
    },
    periodoInicial: {
      label: 'Período inicial',
      placeholder: 'DD/MM/AAAA',
      required: 'Período inicial é obrigatório!',
      invalid: 'Data inválida!',
      afterFinal: 'Deve ser anterior ao período final',
    },
    periodoFinal: {
      label: 'Período final',
      placeholder: 'DD/MM/AAAA',
      required: 'Período final é obrigatório!',
      invalid: 'Data inválida!',
      beforeInicial: 'Deve ser posterior ao período inicial',
    },
    justificativa: {
      label: (infantil?: boolean) =>
        infantil ? 'Narrativa inicial' : 'De onde partimos?',
      placeholder: (infantil?: boolean) =>
        infantil
          ? 'Observações da vida cotidiana das crianças e suas culturas infantis, potências e autonomia das crianças e os direitos de aprendizagem'
          : 'Considere os saberes curriculares/currículo mobilizados que se pretende trabalhar (Disciplinas/Conteúdos/Campos de Experiência)',
      required: 'Campo obrigatório!',
    },
    direitoImagem: {
      label:
        'Me responsabilizo pela autorização de imagens e vídeos anexadas neste projeto',
      hint: 'É de responsabilidade da instituição coletar e guardar os termos de uso de imagem',
    },
    cienciaCordenador: { label: 'Ciência do Coordenador Pedagógico' },
    consultaPublica: { label: 'Permitir consulta pública' },
    descricaoTerritorioInvestigado: {
      label: (infantil?: boolean) =>
        infantil
          ? 'Território escolhido ou construído para ser investigado'
          : 'Território a ser investigado',
      placeholder: 'Digite...',
      required: 'Campo obrigatório!',
      tooltip: 'Clique para ver mais informações',
      modal: {
        title: 'TERRITÓRIO PARA A EXPEDIÇÃO',
        text: [
          {
            subtitle: 'BEBÊS',
            text: [
              getFormattedText(
                '_Crianças de zero a 1 ano e seis meses - Exploradores de si no mundo._'
              ),
              'É o próprio cotidiano, rotinas, interações e brincadeiras vivenciadas nos espaços internos e externos. Um momento planejado pelo(a) educador(a) a partir dos interesses e necessidades dos bebês considerando a organização do plano curricular/projeto. O território escolhido deve propiciar experimentações corporais e sensoriais.',
            ],
          },
          {
            subtitle: 'CRIANÇAS BEM PEQUENAS',
            text: [
              getFormattedText(
                '_Crianças de 1 ano e 7 meses a três anos e 11 meses - Exploradores do mundo_'
              ),
              'Espaços possíveis de serem explorados de acordo com cada grupo etário, previamente planejados e organizados pelo educador, com objetivo de suscitar e valorizar as experiências e curiosidades das crianças.',
              'Exploração de espaços externos ou criados no local de referência. É importante que o território seja desafiador, rico em possibilidades de exploração.',
            ],
          },
          {
            subtitle: 'CRIANÇAS PEQUENAS',
            text: [
              getFormattedText(
                '_Crianças de 4 e 5 anos - Exploradores Investigadores_'
              ),
              'Espaço externo, espaço de aprendizagem como referência. Espaços educacionais (cozinha, pátio...), espaços da comunidade (praças, residências...) ou planejados especificamente para isso. Espaços que permitam encontrar muitas respostas para a pergunta exploratória.',
            ],
          },
        ],
      },
    },
    descricaoPerguntaExploratoria: {
      label: (infantil?: boolean) =>
        infantil
          ? 'Pergunta exploratória (elaborada a partir dos diferentes contextos)'
          : 'Pergunta exploratória',
      placeholder: 'Digite...',
      required: 'Campo obrigatório!',
      tooltip: 'Clique para ver mais informações',
      modal: {
        title: 'PERGUNTA EXPLORATÓRIA',
        text: [
          {
            subtitle: 'BEBÊS',
            text: [
              getFormattedText(
                '_Crianças de zero a 1 ano e seis meses - Exploradores de si no mundo_'
              ),
              'A pergunta exploratória é mediada pelo olhar cuidadoso e escuta sensível do(a) professor(a). A pergunta exploratória é elaborada pelo(a) professor(a) e educador(a), baseado em seu olhar cuidadoso e escuta sensível durante as rotinas escolares, as interações da criança com o ambiente, com seu próprio corpo e suas relações com objetos de conhecimento concreto. Por exemplo: Por que os bebês querem explorar outros espaços? Por que os bebês estão chorando? E o acolhimento cotidiano? O que desafia os bebês? O que precisam? Quais são suas relações de interações?',
            ],
          },
          {
            subtitle: 'CRIANÇAS BEM PEQUENAS',
            text: [
              getFormattedText(
                '_Crianças de 1 ano e 7 meses a três anos e 11 meses - Exploradores do mundo_'
              ),
              'Quando as crianças ainda não se expressam verbalmente (expressam-se de outras maneiras também) a pergunta exploratória direciona a observação do(a) educador(a). Quando já conseguem expressar-se oralmente, elas podem fazer suas perguntas, serem questionados pelo docente que percebeu alguma possibilidade de construção do projeto a partir desses interesses. Nesse caso, ele elabora uma pergunta adequada ao grupo etário (linguagem simples-cotidiana, frase curta).',
            ],
          },
          {
            subtitle: 'CRIANÇAS PEQUENAS',
            text: [
              getFormattedText(
                '_Crianças de 4 e 5 anos - Exploradores Investigadores_'
              ),
              'A pergunta exploratória pode ser feita pelos educadores, unindo currículo e interesse, para que as crianças a tomem como referência para a exploração do território de aprendizagem durante a expedição investigativa. A pergunta deve ser adequada ao grupo etário, de fácil compreensão e não muito extensa.',
            ],
          },
        ],
      },
    },
    descricaoExpedicao: {
      label: (infantil?: boolean) =>
        infantil
          ? 'Realização e narrativa da expedição'
          : 'Descrição da expedição (registro de experiências)',
      placeholder: 'Digite...',
      required: 'Campo obrigatório!',
      tooltip:
        'Por onde andamos e o que observamos? Como foi essa experiência? Registre suas percepções sobre a expedição, seja pelo que pode observar nos bebês ou mesmo os relatos de uma roda de conversa das crianças pequenas ou, ainda, suas representações visuais que talvez tiveram o professor como escriba.',
    },
    fotosVideos: {
      label: 'Fotos e vídeos',
      helperText:
        'Extensões permitidas: jpg, png e mp4. Tamanho máximo do arquivo: 25MB',
    },
    nome: {
      label: 'Título do projeto',
      placeholder: 'Digite o título do projeto...',
      required: 'Título é obrigatório!',
    },
    descricaoIndiceInicial: {
      label: 'Descrição do índice inicial - O que já sabemos?',
      placeholder: 'Digite...',
      required: 'Campo obrigatório!',
      tooltip:
        'O que os bebês/crianças conseguem expressar em relação ao tema definido do projeto? É uma oportunidade de o(a) professor(a) e educador(a) poder perceber o que as crianças desenvolvem com autonomia, suas potencialidades e seus conhecimentos prévios.',
    },
    descricaoIndiceFormativo: {
      label: 'Descrição do índice formativo - O que queremos saber?',
      placeholder: 'Digite...',
      required: 'Campo obrigatório!',
      tooltip:
        'Quais perguntas ou problematização e experiências surgiram? Quais necessidades de desenvolvimento, experiências e aprendizagem o(a) professor(a) e educador(a) percebe? \n  - No caso dos Exploradores de Si no Mundo e Exploradores do Mundo, quais perguntas surgem ao professor(a) frente às necessidades de explorações pedagógicas a partir da vida cotidiana das crianças?\n  - No caso dos Exploradores Investigadores, o que as crianças expressam, a partir de suas singularidades, como interesse? Quais suas curiosidades? Observar quais valores e princípios do PUFV que podem ser contemplados no cotidiano.',
    },
    descricaoComponenteCurricular: {
      label: (infantil?: boolean) =>
        infantil
          ? 'Campos de experiência:'
          : 'Componentes curriculares/Campos de experiência (conteúdos ou saberes desenvolvidos)',
      placeholder: 'Digite...',
      required: 'Campo obrigatório!',
      tooltip:
        'Como podemos mobilizar os campos de experiências, os direitos e objetivos de aprendizagem a partir do que surgiu no Índice Formativo? Contextualize os campos de experiências e como vai mobilizá-los em ações pedagógicas aos bebês e/ou às crianças.',
    },
    descricaoAtividadeDesenvolvida: {
      label: (infantil?: boolean) =>
        infantil
          ? 'Propostas/Ações educativas/Estratégias Pedagógicas'
          : 'Ações pedagógicas de aprendizagem',
      placeholder: 'Digite...',
      required: 'Campo obrigatório!',
      tooltip: 'Atividades desenvolvidas.',
    },
    descricaoComunidadeAprendizagem: {
      label: (infantil?: boolean) =>
        infantil
          ? 'Descrição da comunidade de aprendizagem:'
          : 'Como foi a participação e a contribuição da Comunidade Aprendizagem?',
      placeholder: 'Digite...',
      required: 'Campo obrigatório!',
    },
    apoiadores: {
      label: 'Apoiadores',
      placeholder: 'Digite...',
      required: 'Campo obrigatório!',
      tooltip:
        'Apoiadores são pessoas físicas e/ou jurídicas que apoiam financeiramente ou não para fomento ao Programa.',
    },
    descricaoIndiceFinal: {
      label: 'Como foi o índice final - O que descobrimos e aprendemos?',
      placeholder: 'Digite...',
      required: 'Campo obrigatório!',
      tooltip:
        'O que os bebês/crianças desenvolveram (olhar do(a) professor(a) em relação às suas demandas, necessidades e interesses). Narrativas de observações realizadas.',
    },
    descricaoAtividadeIntegradora: {
      label: 'Como foi a atividade integradora?',
      placeholder: 'Digite...',
      required: 'Campo obrigatório!',
      tooltip: 'Como foi a socialização das aprendizagens e experiências?',
    },
    idPrincipiosValores: {
      label: (infantil?: boolean) =>
        infantil
          ? 'Quais os princípios e valores do Programa foram desenvolvidos nas ações do projeto?'
          : 'Quais princípios e valores do Programa foram desenvolvidos?',
      placeholder: 'Selecione...',
      loading: 'Carregando princípios e valores...',
      required: 'Selecione pelo menos um!',
    },
    descricaoMarcouEducador: {
      label: (infantil?: boolean) =>
        infantil
          ? 'Narrativas dos protagonistas do projeto:'
          : 'O que mais lhe marcou como educador(a) no percurso do projeto? (Opcional)',
      placeholder: (infantil?: boolean) =>
        infantil
          ? 'Crianças, professores, comunidades, participantes do projeto, revelando o protagonismo do processo (preenchimento opcional)'
          : 'Digite...',
      required: 'Campo obrigatório!',
      tooltip:
        'Espaço para visibilizar o que as crianças, os familiares, assessores(as) e gestão sentiram, pensaram por meio das experiências vividas. Quanto ao projeto dos bebês essa narrativa pode ser feita pelos familiares com relação às mudanças percebidas em casa, no contexto fora da escola.',
    },
    checkProfGestor: { label: 'Visualizado por Professor Gestor' },
    checkCoordenador: { label: 'Visualizado por Coordenador Local' },
    observacoes: {
      label: 'Observações',
      placeholder: 'Digite...',
      required: 'Campo obrigatório!',
    },
  },
  actions: {
    closeModal: 'Fechar',
    concluirAvancar: 'Concluir e avançar etapa',
    anterior: 'Anterior',
    proxima: 'Próxima',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    sair: 'Sair'
  },
  modals: {
    confirmChangeEtapa: {
      title: 'Sair da etapa',
      text: 'Você tem certeza de que deseja sair sem concluir? As alterações não serão salvas',
    },
    cancelChangeEtapa: {
      text: 'Você tem certeza que deseja sair dessa página? Todo progresso não salvo será perdido.',
    },
    uploadFotosVideos: {
      title:
        'Lembrando que as imagens e vídeos exibidas devem possuir autorização de uso de imagem, conforme registrado anteriormente',
    },
    historicoModal: {
      title: 'Histórico de avaliações',
      por: 'Por:',
    },
    assessorOuProfessorSaindo: {
      title: 'Saíndo do projeto',
      text: 'Você está saindo do projeto. Ao sair do projeto e não se vincular ao mesmo você perderá acesso. Deseja prosseguir mesmo assim?',
    },
  },
  pages: {
    projetos: {
      etapas: {
        [EtapaProjeto.infosIniciais]: {
          name: 'Informações Iniciais',
          tooltipName: 'Informações Iniciais',
          tooltipText:
            'Preencha as informações que serão importantes para a identificação do seu projeto',
        },
        [EtapaProjeto.curriculo]: {
          name: (infantil?: boolean) =>
            infantil
              ? 'Saberes das crianças, conhecimentos curriculares e intencionalidades'
              : 'Currículo',
          tooltipName: (infantil?: boolean) =>
            infantil
              ? 'Saberes das crianças, conhecimentos curriculares e intencionalidades'
              : 'Currículo',
          tooltipText: (infantil?: boolean) =>
            infantil
              ? 'O que foi percebido como fator de destaque a partir dos eixos Interações e Brincadeiras infantis? Quais culturas, linguagens, aspectos da vida cotidiana podem ser retomados enquanto objeto de aprendizagem? Quais os campos de experiência, direitos de aprendizagem e desenvolvimento podem ser trabalhados a partir destas observações?\nO educador nesta etapa define suas intenções a partir da vida cotidiana das crianças.'
              : 'Apresente qual o conjunto de saberes que pretende privilegiar para a organização da expedição investigativa. É a intenção pedagógica baseada no currículo e/ou nos planos de estudo.',
        },
        [EtapaProjeto.expedicao]: {
          name: 'Expedição Investigativa',
          tooltipName: 'Expedição Investigativa',
          tooltipText: (infantil?: boolean) =>
            infantil
              ? 'Análise Inicial: Da narrativa inicial decorre a definição do território para a expedição investigativa. Como aquilo observado, vivido e explorado no grupo levou a tomada das decisões? O que justifica a escolha desse território?'
              : 'Descreva como foi esse processo na expedição realizada e como foi o registro das experiências vividas no território.',
        },
        [EtapaProjeto.tituloDoProjeto]: {
          name: 'Título do Projeto',
          tooltipName: 'Título do Projeto',
          tooltipText: (infantil?: boolean) =>
            infantil
              ? 'Nem sempre o título inicial é o que permanece, pois no decorrer do projeto, das interações e vivências das crianças pode haver alteração para que o título seja mais significativo e condizente com o vivido e aprendido.'
              : 'Após a socialização dos registros, as crianças e adolescentes são incentivadas a revelar qual poderá ser o título do projeto a ser desenvolvido.',
        },
        [EtapaProjeto.indices]: {
          name: 'Índices Inicial e Formativo',
          tooltipName: 'Índices Inicial e Formativo',
          tooltipText: (infantil?: boolean) =>
            infantil
              ? ''
              : 'No índice inicial os educandos devem revelar o que já sabem sobre o tema do projeto eleito pelo grupo, descreva aqui os conhecimentos prévios deles. No índice formativo, os educandos expressam os seus interesses de aprendizagem, descreva quais são eles.',
        },
        [EtapaProjeto.mobilizacao]: {
          name: (infantil?: boolean) =>
            infantil
              ? 'Mobilização dos Conhecimentos Educativos'
              : 'Articulação com o Currículo/Mobilização dos Saberes Escolares',
          tooltipName: (infantil?: boolean) =>
            infantil
              ? 'Mobilização dos Conhecimentos Educativos'
              : 'Articulação com o Currículo/Mobilização dos Saberes Escolares',
          tooltipText: (infantil?: boolean) =>
            infantil
              ? ''
              : 'Descreva quais os saberes curriculares estão sendo mobilizados e identifique as ações que estão sendo desenvolvidas para atender as questões dos índices inicial e formativo. Não esqueça da interdisciplinaridade neste momento!',
        },
        [EtapaProjeto.aprendizagem]: {
          name: 'Comunidade de Aprendizagem',
          tooltipName: 'Comunidade de Aprendizagem',
          tooltipText: (infantil?: boolean) =>
            infantil
              ? 'Muitas questões dos educandos podem ser respondidas por meio de pessoas ou entidades da comunidade. Esta etapa é muito importante para a construção do conhecimento em conjunto com os saberes curriculares.'
              : 'Muitas questões dos educandos podem ser respondidas por meio de pessoas ou entidades da comunidade. O envolvimento da comunidade de aprendizagem é muito importante para a construção do conhecimento em conjunto com os saberes curriculares.',
        },
        [EtapaProjeto.indiceFinal]: {
          name: 'Índice Final',
          tooltipName: 'Índice Final',
          tooltipText:
            'Descreva as aprendizagens adquiridas neste projeto, este é o índice final. As atividades integradoras são ações que comunicam o que os educandos aprenderam e podem ser de diferentes formas. Relate como foi a deste projeto.',
        },
        [EtapaProjeto.revisao]: {
          name: 'Revisão e Finalização',
          tooltipName: 'Revisão e Finalização',
          tooltipText: '',
        },
      },
      statusEtapa: {
        [StatusEtapa.SemPreenchimento]: '',
        [StatusEtapa.AguardandoAprovacao]: 'Pendente de aprovação',
        [StatusEtapa.Aprovada]: 'Aprovada',
        [StatusEtapa.Disabled]: '',
        [StatusEtapa.PontoDeAtencao]: 'Ponto de atenção',
      },
      notFullfilled: 'Não preenchido',
      actions: {
        approve: 'Aprovar etapa',
        attentionPoint: 'Ponto de atenção na etapa',
        viewComments: 'Visualizar comentários da etapa',
      },
    },
    escolas: {
      labels: {
        documentos: 'Documentos',
        Obrigatorio: '(obrigatório)',
        AtaDaCooperativaEscolar: 'Ata da Cooperativa Escolar',
        EstatutoDaCooperativaEscolar: 'Estatuto da Cooperativa Escolar',
        CadastrarCooperativasEscolares: 'Cadastrar cooperativas escolares',
        CadastrarCooperativaEscolar: 'Cadastrar cooperativa escolar',
        InformaçõesGeraisDosProgramasEducacionais:
          'Informações gerais dos programas educacionais',
        PreenchaOsDadosSobreOsProgramasEducacionaisQueSuaInstituiçãopossui:
          'Preencha os dados sobre os programas educacionais que sua instituição possui:',
        PreenchaOsDadosSobreOsPeríodosDosProgramasEducacionaisQueSuaEscolaPossuí:
          'Preencha os dados sobre os períodos dos programas educacionais que sua escola possuí',
        CadastroDeDadosDosAnosDosProgramasEducacionais:
          'Cadastro de dados dos anos dos programas educacionais',
        CadastroDeDadosDoAnoDoAUniãoFazAVida:
          'Cadastro de dados do ano do A União Faz a Vida',
        AnoImplementacao: 'Ano de implementação do programa',
      },
      buttons: {
        salvar: 'Salvar',
        salvarProsseguir: 'Salvar e prosseguir',
        anterior: 'Anterior',
        cancelar: 'Cancelar',
        download: 'Download',
        excluir: 'Excluir',
        remover: 'Remover',
        cadastrarDados: 'Cadastrar dados',
        sim: 'Sim',
        nao: 'Não',
      },
      modals: {
        removerCoopModal: {
          title: 'Removendo Cooperativa Escolar',
          text: 'Você deseja remover a Cooperativa Escolar?'
        },
        cancelAddCoopModal: {
          title: 'Aviso',
          text: 'As alterações feitas nos documentos ou informações não foram salvas. Tem certeza que deseja sair?'
        }
      },
      snackbar: {
        coopRemovidaSucesso: 'Cooperativa removida com sucesso',
        coopRemovidaFalha: 'Erro ao remover cooperativa escolar',
        coopSalvarSucesso: 'Cooperativa cadastrada com sucesso',
        coopSalvarFalha: 'Erro ao cadastrar cooperativa escolar',
        coopSalvarFalhaTamanhoArquivo: 'O tamanho máximo permitido é de 31MB por arquivo.',
        coopEditarSucesso: 'Cooperativa atualizada com sucesso',
        coopEditarFalha: 'Erro ao atualizar cooperativa escolar',
      },
      tooltips: {
        possuiDadosRemoverPrograma: 'Para excluir um programa é necessário remover os dados já cadastrados para este programa.'
      }
    },
  },
  toasts: {
    error: {
      fileSize: 'Tamanho máximo permitido é de 25MB!',
      imageVideoSize:
        'Tamanho máximo permitido é de 25MB para vídeos e 10MB para imagens!',
      fileType: 'Formato de arquivo não permitido!',
      saveEtapa: 'Erro ao salvar etapa!',
      visto: 'Erro ao marcar a visualização!',
      erroVerificacaoIsGestor: 'Erro na chamada isGestor',
      avaliarEtapa: 'Erro ao enviar avaliação!',
      loadEducadores: 'Erro ao carregar educadores!',
      loadAssessores: 'Erro ao carregar assessores!',
      loadProjeto: 'Erro ao carregar projeto!',
      loadCoops: 'Erro ao carregar cooperativas!',
      loadModalidades: 'Erro ao carregar modalidades!',
      loadEtapasEducacao: 'Erro ao carregar etapas da educação!',
      loadPrincipiosValores: 'Erro ao carregar princípios e valores!',
      loadInstituicoes: 'Erro ao carregar instituições!',
      saveFiles: 'Erro ao salvar documentos!',
      schoolNotFound: 'Escola não encontrada',
      educationalProgramsSearchError:
        'Erro ao buscar os programas educacionais',
      educationalProgramsSavingError:
        'Erro ao salvar os programas educacionais',
      principioValorBase:
        'Os princípios de "Cooperação" e "Cidadania" não podem ser desmarcados!',
      errorWhenSavingYear: 'Erro ao salvar o ano de implementação',
      errorWhenSavingYearStructure: 'Erro ao salvar o ano de implementação',
      carregarContratosAssessorDescentralizado: 'Erro ao carregar os contratos de assessor descentralizado.',
      carregarContratosEntePublicoDescentralizado: 'Erro ao carregar os contratos do ente público descentralizado.',
      carregarContratosEntePrivadoDescentralizado: 'Erro ao carregar os contratos do ente privado descentralizado.',
      carregarContratosAssessoresDescentralizadosAdendos: 'Erro ao carregar adendos de contratos do assessor descentralizado.',
      carregarContratosEntePublicoDescentralizadosAdendos: 'Erro ao carregar adendos de contratos do ente-público descentralizado.',
      carregarContratosEntePrivadoDescentralizadosAdendos: 'Erro ao carregar adendos de contratos do ente-privado descentralizado.',
      carregarDocumentosAuxiliares: 'Erro ao carregar lista de documentos auxiliares.',
      erroTamanhoDeArquivo: 'Seu envio excede o tamanho de 130MB. Por favor, tente novamente encaminhando um número menor de arquivos por vez.',
      carregarPesquisaUsuario: 'Não foi possível carregar a pesquisa do usuário',
      salvarPesquisa: 'Não foi possível atualizar pesquisa',
    },
    success: {
      saveEtapa: 'Alterações salvas!',
      saveUpload: 'Enviado com sucesso!',
      createProjeto: 'Projeto cadastrado!',
      visto: (val: boolean) => `Visto ${val ? '' : 'des'}marcado!`,
      etapaAprovada: 'Etapa aprovada com sucesso!',
      pontoDeAtencao: 'Ponto de atenção inserido com sucesso!',
      ImplementationYearSavedSuccessfully:
        'Ano de implementação salvo com sucesso',
    },
  },
  validations: {
    erroCentralValida: 'Erro na validação da central',
    erroCooperativaValida: 'Erro na validação da cooperativa',
    erroPerfilValida: 'Erro na validação do perfil',
    erroEscolaValida: 'Erro na validação da escola',
    erroCidadeValida: 'Erro na validação da cidade',
    erroEstadoValida: 'Erro na validação do estado',
    erroStatusValida: 'Erro na validação do status',
    erroCarregarContrato: 'Erro ao carregar contrato.',
  },
};
export default languageValues;
